import { FieldError, useFormContext } from 'react-hook-form';

interface Props {
  label: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
  noPadding?: boolean;
  halfWidth?: boolean;
  checked?: boolean;
  justifyStart?: boolean;
}

const FormCheckbox = ({
  label,
  name,
  required,
  disabled,
  noPadding,
  halfWidth,
  checked,
  justifyStart,
}: Props): JSX.Element => {
  const { formState, register } = useFormContext();
  const error = formState.errors?.[name] as FieldError | undefined;

  return (
    <div
      className={`input-form-container font-ic self-start md:px-2 relative rounded-md checkbox-container border-0 border-none items-center 
       md:pt-2 ${noPadding === true ? '' : 'pb-5 md:pb-6'} ${
        halfWidth === true ? 'inline-flex pr-4 md:pl-0 md:pr-4' : 'w-full flex'
      } ${justifyStart === true ? 'md:justify-start' : 'md:justify-end'}`}
    >
      <label className="text-black500 top-0 text-tiny pr-0 mb-0 flex items-center cursor-pointer">
        <input
          className="checkbox"
          {...register(name, { required })}
          type="checkbox"
          readOnly={disabled}
          defaultChecked={checked}
        />
        <span className="checkmark"></span>
        <div className="my-0" dangerouslySetInnerHTML={{ __html: label }}></div>
      </label>
      <p className="m-0 absolute text-red500 text-tiny bottom-1">
        {error?.type === 'required' && 'Du måste godkänna integritetspolicyn'}
      </p>
    </div>
  );
};
export default FormCheckbox;
